/** Comparación de búsqueda: minúsculas y sin tildes. */
export function normalizeSearch(value: string): string {
  return value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
}

export function matchesSearch(value: string | null | undefined, query: string): boolean {
  const needle = normalizeSearch(query.trim());
  if (!needle) return true;
  return normalizeSearch(value ?? '').includes(needle);
}
